import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function IntroSplash({ visible, onComplete }) {
  const [count, setCount] = useState(5);
  const [stage, setStage] = useState("countdown");

  useEffect(() => {
    if (!visible) {
      return undefined;
    }
    setCount(5);
    setStage("countdown");
    let currentCount = 5;
    let clapperTimer;
    const timer = window.setInterval(() => {
      if (currentCount > 1) {
        currentCount -= 1;
        setCount(currentCount);
        return;
      }
      window.clearInterval(timer);
      setStage("clapper");
      clapperTimer = window.setTimeout(onComplete, 1800);
    }, 1000);
    return () => {
      window.clearInterval(timer);
      window.clearTimeout(clapperTimer);
    };
  }, [onComplete, visible]);

  const showClapper = stage === "clapper";

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          animate={{ opacity: 1 }}
          className="intro-splash"
          exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
          initial={{ opacity: 0 }}
          data-testid="intro-splash"
        >
          {!showClapper ? (
            <motion.div
              animate={{ opacity: 1, scale: 1 }}
              className="film-countdown"
              initial={{ opacity: 0, scale: 1.15 }}
              key={count}
              data-testid={`film-countdown-${count}`}
            >
              <strong>{count}</strong>
            </motion.div>
          ) : (
            <div className="clapper-center">
              <motion.div
                animate={{ opacity: 1, scale: 1 }}
                className="clapperboard"
                initial={{ opacity: 0, scale: 0.88 }}
                transition={{ duration: 0.35 }}
                data-testid="film-clapperboard"
              >
                <motion.div
                  animate={{ rotate: -28 }}
                  className="clapper-top"
                  initial={{ rotate: 0 }}
                  transition={{ delay: 0.35, duration: 0.6, type: "spring" }}
                />
                <div className="clapper-body">
                  <div><span>PROD.</span><b>EYLÜL FOTOĞRAFÇILIK</b></div>
                  <div><span>SCENE</span><b>LOVE STORY</b></div>
                  <div><span>TAKE</span><b>01</b></div>
                </div>
                <p>AND... ACTION</p>
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}